export default __webpack_public_path__ + "img/repo.f558bd87.png";